import React from 'react';
import { SEO } from '../components/SEO';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRightIcon, MailIcon, ShieldIcon, CheckCircleIcon, ServerIcon, UsersIcon, FileTextIcon, VideoIcon, BarChartIcon, SendIcon, LockIcon } from 'lucide-react';
export const EmailPage: React.FC = () => {
  const businessEmailFeatures = ['50 GB mailbox opslag per gebruiker', '50 e-mailaliassen en doorstuurregels', 'Tot 3000 e-mails per dag per mailbox', 'Eigen domein e-mail voor professionele uitstraling', 'Outlook integratie en werkt met alle mail-apps', 'Spamfilter e-mail en malwarebescherming', 'Gratis domein inbegrepen', 'Catch-all mailbox en automatische antwoorden', 'Importeer bestaande e-mail eenvoudig', 'Geavanceerde beveiliging (SPF, DKIM, DMARC, ARC)', 'Mailhosting MKB en administratiekantoor', 'Geen provider branding', 'Premium ondersteuning', 'Zakelijke mailbox instellen binnen 24 uur'];
  const googleWorkspaceFeatures = ['Professioneel e-mailadres adviesbureau op eigen domein', '30 GB mailbox opslag (uitbreidbaar tot 5 TB)', 'Gmail met krachtige spamfilter en phishing bescherming', 'Agenda, Documenten, Spreadsheets, Presentaties, Chat', 'Videomeetings tot 500 deelnemers inclusief opname', 'AppSheet werkstroomtools', 'Centraal beheer en toegangscontrole', 'Email op domeinnaam voor professionele communicatie', 'Veilige cloudopslag en samenwerking', 'Premium ondersteuning'];
  const emailMarketingFeatures = ['Tot 500 abonnees en 3500 e-mails per maand', 'Uitbreidbaar tot 50.000 abonnees en 350.000 e-mails per maand', 'Onbeperkt contactbeheer', 'Synchroniseer abonnees vanaf je website', 'Campagnes plannen en automatiseren', 'Kant-en-klare sjablonen', 'Spamfilter en aflevergarantie', 'Mailing campagnes voor administratiekantoor en boekhouders', 'Synchronisatie met de website', 'Premium ondersteuning', 'Aangepaste quota mogelijk voor grote campagnes'];
  const solutions = [{
    icon: <MailIcon className="h-6 w-6" data-id="element-1173" />,
    title: 'Zakelijke e-mail hosting',
    description: 'Veilig en professioneel mailen',
    use: 'Voor dagelijkse zakelijke communicatie met klanten en partners. Beveiligde e-mail communicatie met eigen domein e-mail.'
  }, {
    icon: <UsersIcon className="h-6 w-6" data-id="element-1174" />,
    title: 'Google Workspace',
    description: 'Samenwerken en communiceren',
    use: 'Voor teams die veel samenwerken en documenten delen. Professioneel e-mailadres adviesbureau met 5 TB opslag.'
  }, {
    icon: <SendIcon className="h-6 w-6" data-id="element-1175" />,
    title: 'E-mail marketing',
    description: 'Nieuwsbrieven en campagnes',
    use: 'Voor nieuwsbrieven, campagnes en klantcommunicatie. Mailing campagnes voor administratiekantoor.'
  }];
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-1176">
      <SEO title="Zakelijke e-mail hosting | Noord Digital" description="Zakelijke e-mail hosting voor administratie en advieskantoren. Domein e-mail instellen, beveiligde e-mail communicatie en professioneel e-mailadres adviesbureau. Zakelijke e-mail hosting pakket aanvragen." keywords="zakelijke e-mail hosting, domein e-mail instellen administratiekantoor, professioneel e-mailadres adviesbureau, zakelijke e-mail hosting pakket aanvragen, zakelijke mailbox instellen, email op domeinnaam, beveiligde e-mail communicatie, mailhosting MKB, eigen domein e-mail, Outlook integratie, spamfilter e-mail" canonical="https://noorddigital.nl/zakelijke-email-hosting" data-id="element-1177" />
      <Header data-id="element-1178" />

      {/* Section 1: Hero */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#1B2B44] py-16 md:py-20" data-id="element-1179">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1180">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-1181">
            {/* Column 1 */}
            <div className="lg:col-span-7" data-id="element-1182">
              <h1 className="font-bold text-white leading-tight mb-6 text-4xl md:text-5xl lg:text-6xl" data-id="element-1183">
                Zakelijke e-mail hosting voor administratie en advieskantoren
              </h1>
              <p className="text-white text-opacity-90 mb-8 text-lg leading-relaxed" data-id="element-1184">
                Op zoek naar zakelijke e-mail hosting die betrouwbaar en veilig
                is? Noord Digital helpt je met domein e-mail instellen
                administratiekantoor en beveiligde e-mail communicatie. Van
                professioneel e-mailadres adviesbureau tot complete Google
                Workspace oplossingen, wij zorgen dat je e-mail veilig wordt
                verzonden, betrouwbaar aankomt en werkt met alle bekende
                mail-apps zoals Outlook.
              </p>

              <div className="flex flex-wrap gap-4" data-id="element-1185">
                <a href="#email-oplossingen" className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-lg" data-id="element-1186">
                  Plan e-mail advies
                  <ArrowRightIcon className="h-5 w-5 ml-2" data-id="element-1187" />
                </a>
                <a href="/hosting" className="inline-flex items-center px-6 py-3 bg-transparent border-2 border-white text-white font-semibold rounded-lg" data-id="element-1188">
                  Bekijk hosting
                  <ArrowRightIcon className="h-5 w-5 ml-2" data-id="element-1189" />
                </a>
              </div>
            </div>

            {/* Column 2 */}
            <div className="lg:col-span-5" data-id="element-1190">
              <div className="bg-white rounded-2xl p-8 shadow-2xl" data-id="element-1191">
                <div className="text-center mb-6" data-id="element-1192">
                  <div className="inline-flex items-center justify-center w-32 h-32 bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-full mb-4 p-3" data-id="element-1193">
                    <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden mascotte - zakelijke e-mail hosting" className="w-full h-full object-cover rounded-full" data-id="element-1194" />
                  </div>
                  <h3 className="font-bold text-[#111827] text-2xl mb-2" data-id="element-1195">
                    Norden bewaakt jouw e-mailverkeer
                  </h3>
                  <p className="text-[#6B7280]" data-id="element-1196">
                    Zakelijke e-mail hosting met beveiligde communicatie
                  </p>
                </div>

                <div className="space-y-3 pt-6 border-t border-gray-200" data-id="element-1197">
                  <div className="flex items-center gap-3" data-id="element-1198">
                    <ShieldIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1199" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1200">
                      Geavanceerde beveiliging (SPF, DKIM, DMARC, ARC)
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1201">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1202" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1203">
                      Outlook integratie en alle mail-apps
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1204">
                    <LockIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1205" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1206">
                      Spamfilter e-mail en geen provider branding
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: Business Email */}
      <div id="email-oplossingen" className="w-full bg-white py-20 md:py-24" data-id="element-1207">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1208">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1209">
            <h2 className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1210">
              Onze zakelijke e-mail hosting in één overzicht
            </h2>
            <p className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1211">
              Een complete zakelijke e-mail hosting oplossing voor professionele
              communicatie met klanten en partners. Inclusief domein e-mail
              instellen en beveiligde e-mail communicatie.
            </p>
          </div>

          <div className="bg-[#F7F8FA] rounded-2xl p-8 md:p-12 max-w-4xl mx-auto" data-id="element-1212">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-1213">
              {businessEmailFeatures.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-1214">
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF] mt-0.5 flex-shrink-0" data-id="element-1215" />
                  <span className="text-[#6B7280]" data-id="element-1216">{feature}</span>
                </div>)}
            </div>

            <div className="pt-6 border-t border-gray-300" data-id="element-1217">
              <p className="text-[#6B7280] leading-relaxed" data-id="element-1218">
                Deze oplossing is ideaal wanneer je vooral veilig en
                professioneel wilt mailen zonder onnodige extra functies.
                Perfect voor zzp'ers en kleine bedrijven die betrouwbare
                zakelijke e-mail hosting nodig hebben. Wij helpen je met
                zakelijke mailbox instellen en email op domeinnaam configureren.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3: Google Workspace */}
      <div className="w-full bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] py-20 md:py-24" data-id="element-1219">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1220">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1221">
            <h2 className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1222">
              Google Workspace: samenwerken en communiceren
            </h2>
            <p className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1223">
              Professioneel e-mailadres adviesbureau op basis van je eigen
              domein met krachtige spamfilter en tot 5 TB opslag. De complete
              oplossing voor teams die veel samenwerken en documenten delen.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 max-w-4xl mx-auto shadow-lg" data-id="element-1224">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-1225">
              {googleWorkspaceFeatures.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-1226">
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF] mt-0.5 flex-shrink-0" data-id="element-1227" />
                  <span className="text-[#6B7280]" data-id="element-1228">{feature}</span>
                </div>)}
            </div>

            <div className="pt-6 border-t border-gray-300 mb-6" data-id="element-1229">
              <p className="text-[#6B7280] leading-relaxed mb-4" data-id="element-1230">
                Google Workspace biedt professionele e-mailadressen op basis van
                je eigen domein, gecombineerd met krachtige samenwerkingstools.
                Met geïntegreerde spamfilter, phishing bescherming en tot 5 TB
                opslag is dit de ideale oplossing voor adviesbureaus en teams
                die efficiënt willen samenwerken. Email op domeinnaam voor
                maximale professionaliteit.
              </p>
              <a href="https://workspace.google.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#007AFF] font-medium" data-id="element-1231">
                Lees meer over Google Workspace
                <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-1232" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Section 4: Email Marketing */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1233">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1234">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1235">
            <h2 className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1236">
              E-mail marketing en nieuwsbrieven
            </h2>
            <p className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1237">
              Professionele oplossing voor nieuwsbrieven, campagnes en
              klantcommunicatie. Ideaal voor mailing campagnes voor
              administratiekantoor en boekhouders.
            </p>
          </div>

          <div className="bg-[#F7F8FA] rounded-2xl p-8 md:p-12 max-w-4xl mx-auto" data-id="element-1238">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-1239">
              {emailMarketingFeatures.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-1240">
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF] mt-0.5 flex-shrink-0" data-id="element-1241" />
                  <span className="text-[#6B7280]" data-id="element-1242">{feature}</span>
                </div>)}
            </div>

            <div className="pt-6 border-t border-gray-300" data-id="element-1243">
              <p className="text-[#6B7280] leading-relaxed" data-id="element-1244">
                Deze oplossing is bedoeld voor nieuwsbrieven, campagnes en
                klantcommunicatie, niet voor dagelijkse e-mail. Ideaal voor
                bedrijven die regelmatig updates willen sturen naar hun
                klantenbestand of leads willen opvolgen met geautomatiseerde
                campagnes. Synchroniseer eenvoudig abonnees vanaf je website en
                profiteer van spamfilter en aflevergarantie.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 5: Norden Email Security */}
      <div className="w-full bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] py-20 md:py-24" data-id="element-1245">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1246">
          <div className="max-w-4xl mx-auto" data-id="element-1247">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-1248">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1249">
                {/* Column 1 */}
                <div className="text-center md:text-left" data-id="element-1250">
                  <div className="inline-block" data-id="element-1251">
                    <div className="w-48 h-48 bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-full flex items-center justify-center p-4" data-id="element-1252">
                      <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden bewaakt zakelijke e-mail hosting en beveiligde communicatie" className="w-full h-full object-cover rounded-full" data-id="element-1253" />
                    </div>
                  </div>
                </div>

                {/* Column 2 */}
                <div data-id="element-1254">
                  <h2 className="font-bold text-[#111827] text-3xl mb-4" data-id="element-1255">
                    Norden bewaakt jouw e-mailverkeer
                  </h2>
                  <p className="text-[#6B7280] text-lg leading-relaxed mb-6" data-id="element-1256">
                    Norden staat symbool voor hoe wij omgaan met zakelijke
                    e-mail hosting. Hij bewaakt de aflevering, beschermt tegen
                    phishing en zorgt dat belangrijke berichten aankomen waar ze
                    horen. Met geavanceerde beveiligingsprotocollen zoals SPF,
                    DKIM, DMARC en ARC ben je optimaal beschermd tegen spam en
                    ongewenste e-mail.
                  </p>
                  <div className="space-y-3" data-id="element-1257">
                    <div className="flex items-center gap-3" data-id="element-1258">
                      <div className="w-6 h-6 bg-[#007AFF] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1259">
                        <CheckCircleIcon className="h-4 w-4 text-white" data-id="element-1260" />
                      </div>
                      <span className="text-[#6B7280]" data-id="element-1261">
                        Bescherming tegen phishing en spam
                      </span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-1262">
                      <div className="w-6 h-6 bg-[#007AFF] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1263">
                        <CheckCircleIcon className="h-4 w-4 text-white" data-id="element-1264" />
                      </div>
                      <span className="text-[#6B7280]" data-id="element-1265">
                        Betrouwbare aflevering van e-mails
                      </span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-1266">
                      <div className="w-6 h-6 bg-[#007AFF] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1267">
                        <CheckCircleIcon className="h-4 w-4 text-white" data-id="element-1268" />
                      </div>
                      <span className="text-[#6B7280]" data-id="element-1269">
                        Professionele uitstraling zonder branding
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 6: Which Solution */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1270">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1271">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1272">
            <h2 className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1273">
              Wanneer kies je welke oplossing?
            </h2>
            <p className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1274">
              Elke oplossing heeft zijn eigen sterke punten. Kies de oplossing
              die het beste past bij jouw manier van werken en communiceren. Wil
              je een zakelijke e-mail hosting pakket aanvragen? Neem contact op
              voor persoonlijk advies.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1275">
            {solutions.map((solution, index) => <div key={index} className="bg-[#F7F8FA] rounded-2xl p-6" data-id="element-1276">
                <div className="w-12 h-12 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center text-[#007AFF] mb-4" data-id="element-1277">
                  {solution.icon}
                </div>
                <h3 className="font-bold text-[#111827] text-lg mb-2" data-id="element-1278">
                  {solution.title}
                </h3>
                <p className="text-[#007AFF] font-medium text-sm mb-3" data-id="element-1279">
                  {solution.description}
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed mb-4" data-id="element-1280">
                  {solution.use}
                </p>
                <a href="/contact" className="inline-flex items-center justify-center w-full bg-[#007AFF] text-white font-semibold py-2 px-4 rounded-lg text-sm shadow-md" data-id="element-1281">
                  Plan e-mail advies
                  <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-1282" />
                </a>
              </div>)}
          </div>

          <div className="bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-1283">
            <h3 className="font-bold text-[#111827] text-xl mb-4 text-center" data-id="element-1284">
              Complete oplossing voor jouw online communicatie
            </h3>
            <p className="text-[#6B7280] text-center mb-6" data-id="element-1285">
              Combineer je zakelijke e-mail hosting met onze andere diensten
              voor een professionele online aanwezigheid:
            </p>
            <div className="flex flex-wrap gap-4 justify-center" data-id="element-1286">
              <a href="/hosting" className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm" data-id="element-1287">
                Hosting voor bedrijven
                <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-1288" />
              </a>
              <a href="/websites" className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm" data-id="element-1289">
                Website laten maken
                <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-1290" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer data-id="element-1291" />
    </div>;
};